class UserTemplates {
  templates: PreBuiltQuestionsType[];

  constructor(params?: UserTemplates) {
    this.templates = params?.templates || [];
  }
}

export { UserTemplates };
